export default {
    serviceCategories: 'نوع خدمت',
    serviceCategoriesTitle: 'عنوان',
    serviceCategoriesStatus: 'وضعیت',
    editServiceCategories: 'ویرایش نوع خدمت',
    addServiceCategories: 'نوع خدمت جدید',
    serviceCategoriesType: 'نوع',
    serviceCategoriesSubType: 'زیر نوع',
    serviceCategoriesLab: 'آزمایش',
    serviceCategoriesSonography: 'سونوگرافی',
    serviceCategoriesVisit: 'ویزیت',
    serviceCategoriesSurgery: 'جراحی',
    serviceCategoriesRadiology: 'رادیولوژی',
    serviceCategoriesInjections: 'تزریقات',
    serviceCategoriesConsumables: 'لوازم مصرفی',
    serviceCategoriesContract: 'قرارداد',


    sonography: 'سونوگرافی',
    ovarianUterineAndVaginalSurgeries: 'جراحی های رحم و واژن تخمدان',
    menSurgeries: 'جراحی های مردانه',
    infertility: 'ناباروری',
    lab: 'آزمایش',
    visit: 'ویزیت',
    otherSurgeries: 'سایر جراحی ها ',
    eyeSurgery: 'جراحی چشم',
    traumaSurgery: 'جراحی تروما ',
    breastSurgery: 'جراحی سینه ',
    generalSurgery: 'جراحی عمومی',
    heartSurgery: 'جراحی قلب ',
    orthopedicSurgery: 'جراحی ارتوپدی ',
    respiratorySystemSurgery: 'جراحی سیستم تنفسی ',
    cosmeticSurgery: 'جراحی زیبایی',
    neurologicalSurgery: 'جراحی مغز و اعصاب ',
    gastrointestinalSurgeries: 'جراحی های گوارشی ',
    radiologyMri: 'رادیولوژی Mri',
    radiologyCtScan: 'رادیولوژی CtScan',
    radiologyMammography: 'رادیولوژی ماموگرافی',






}